<template>
  <el-button class="button-m" v-if="useCategory" @click="$emit('select', useCategory)" round>
    {{useCategory.Name}}
    <b-icon name="A" class="el-icon-right" height="30px" v-if="useCategory.Aromatic"/>
    <b-icon name="I" class="el-icon-right" height="30px" v-if="useCategory.Internal"/>
    <b-icon name="T" class="el-icon-right" height="30px" v-if="useCategory.Topical"/>
  </el-button>
</template>

<script>
export default {
  props: {
    useCategory: {
      type: Object,
      default: () => {}
    }
  },
  methods: {}
}
</script>

<style scoped>
.el-icon-right {
  margin-left: 5px;
}
.button-m {
  margin-left: 10px;
  margin-bottom: 10px;
}
</style>
